module.exports = __webpack_public_path__ + "static/img/H26_2.1121887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H26_2.png
// module id = SJEf
// module chunks = 0